import React, { useEffect, useState } from 'react';
interface ReadingProgressProps {
  color?: string;
}
export function ReadingProgress({
  color = '#001E79'
}: ReadingProgressProps) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    let ticking = false;
    const updateProgress = () => {
      const scrollPx = document.documentElement.scrollTop;
      const winHeightPx = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = winHeightPx > 0 ? scrollPx / winHeightPx * 100 : 0;
      setProgress(scrolled);
      ticking = false;
    };
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Initial call
    updateProgress();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 right-0 h-[2px] z-[9999] pointer-events-none" style={{
    backgroundColor: 'transparent'
  }} data-id="element-421">
      <div className="h-full transition-all duration-150 ease-out" style={{
      width: `${progress}%`,
      backgroundColor: color
    }} data-id="element-422" />
    </div>;
}